export const toQuery = (hash) => {
  return Object.keys(hash)
    .filter((k) => hash[k])
    .map((k) => [k, hash[k]].map(encodeURIComponent).join('='))
    .join('&');
};

export const fromQuery = (query) => {
  const withoutQuestionMark = query.replace(/^\?/, '');
  return withoutQuestionMark.split('&').reduce((acc, pair) => {
    const [key, value] = pair.split('=').map(decodeURIComponent);
    return { ...acc, [key]: value };
  }, {});
};
